import type { Reason } from '~/fecom-api/schema';

export class InvalidItemError extends Error {
  reason: Reason;
  constructor(reason: Reason) {
    super('Invalid item');
    this.reason = reason;
    this.name = 'InvalidItemError';
  }
}
